const Content = {
  'expertise': {
    'title': 'OUR STORY',
    'body': 'For 40 years, NRG has helped the world’s largest content creators & marketers connect their stories with audiences on every screen. Our expertise in brand management, content strategy and storytelling puts us at the intersection of entertainment and technology.',
    'image': '../../assets/img/history.jpg',
    'year': '',
    'footer': ''
  }
};

export { Content };
